/* global globalThis */
import ReactGA from "react-ga4";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-json-view-lite/dist/index.css";
import Header from "./Components/Header/Header";
import AppRouter from "./Router/AppRouter";


function App() {
  if (globalThis?.IS_GA_ENABLED === "TRUE" && globalThis?.GA_MEASUREMENT_KEY) {
    ReactGA.initialize(globalThis.GA_MEASUREMENT_KEY, {
      gaOptions: {
        cookieFlags: "Secure;SameSite=None",
      },
    });
  }
  return (
    <div className="main-container">
      <ToastContainer autoClose={500} pauseOnFocusLoss={false} />
      <div className="content-area-wrap">
        <Header />
        <AppRouter />
      </div>
    </div>
  );
}

export default App;
